import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaAdmissionDEData } from "@/src/types/admissionOffice";
import type { DoubleLangCountry, SecondLangCode } from "./admissionLetterDoubleLangRegistry";
import { MALTA_UZB_RUSSIAN_SIGNATURE } from "@/src/constants/AdmissionOffice/Malta/AOMaltaUzbConsts";

const emptyState = (): AOPMaltaAdmissionDEData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  invoiceBody: [],
  body: [],
  bodySecondLanguage: [],
  invoiceBodySecondLanguage: [],
  nationalitySecondLanguage: "",
  courseSecondLanguage: "",
  mediumOfInstructionSecondLanguage: "",
  durationSecondLanguage: "",
});

export interface AOPAdmissionLetterDoubleLangLayoutProps {
  country: DoubleLangCountry;
  secondLang: SecondLangCode;
}

const AOPAdmissionLetterDoubleLangLayout = ({ country, secondLang }: AOPAdmissionLetterDoubleLangLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaAdmissionDEData>(emptyState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaAdmissionDEData>(emptyState);
  const [showInvoiceInPreview, setShowInvoiceInPreview] = useState(false);
  const [withQR, setWithQR] = useState(true);
  const [selectedSignature, setSelectedSignature] = useState(
    secondLang === "uzb" ? MALTA_UZB_RUSSIAN_SIGNATURE : "Fedorova Anzhelika",
  );

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        secondLang={secondLang}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setShowInvoiceInPreview={setShowInvoiceInPreview}
        setWithQRForPreview={setWithQR}
        setSelectedSignatureForPreview={setSelectedSignature}
      />
      <AOPPrev
        country={country}
        secondLang={secondLang}
        bodyForPrev={bodyForPrev}
        showInvoiceInPreview={showInvoiceInPreview}
        withQR={withQR}
        selectedSignature={selectedSignature}
      />
    </div>
  );
};

export default AOPAdmissionLetterDoubleLangLayout;
